(function () {
  ReviewController.$inject = ["API_URL", "$http", "$location", "$filter", "$rootScope"];
  angular.module('calendarApp').controller('ReviewController', ReviewController);

  function ReviewController(API_URL, $http, $location, $filter, $rootScope) {
    var review = this;

    review.init = function () {
      // All appointments at this stage must be in local storage
      var appointments = localStorage.getItem('reserved-appointments');
      localStorage.removeItem('requires-payment');

      try {
        appointments = JSON.parse(appointments);
      } catch (err) {
        console.error('Could not parse appointments');
        return $location.path('/');
      }

      if (!appointments || !appointments.length) {
        return $location.path('/');
      }

      review.appointments = appointments;
      review.serviceID = review.appointments[0].serviceid._id;
      review.shiftID = review.appointments[0].shiftid._id || review.appointments[0].shiftid;
      var shift = appointments[0].shiftid;
      review.shift = shift;
      review.calendarSettings = smooth.calendarSettings;
      review.mustAgreeTerms = !!(review.calendarSettings.tsandcsrequired && review.calendarSettings.tsandcs);
      review.termsAgreed = false; // Retrieve payment options for this user and this service

      $rootScope.throbber.show();
      $http.get(API_URL + '/api/v1/calendar/payment/options/' + review.shiftID).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          var errorMessage = $filter('calendarLabel')('Sorry but an error occurred: ');
          $rootScope.throbber.showError(errorMessage + ' ' + response);
          return;
        }

        review.requiresPayment = response.requirespayment;

        if (review.requiresPayment) {
          localStorage.setItem('requires-payment', JSON.stringify(review.requiresPayment));
        }
      }, function (error) {
        $rootScope.throbber.hide();
        var errorMessage = $filter('calendarLabel')('Sorry but an error occurred: ');
        $rootScope.throbber.showError(errorMessage + ' ' + error);
      });
    };

    review.init();

    review.continue = function () {
      // 1. Determine if forms need to be completed:
      //  - Registration if its required
      //  - Booking form if it exists for this service or a default has been defined
      // 2. If none of the above, determine if payment is required.
      //  - If it is, redirect to payment page
      if (smooth.calendarSettings.regoformcompulsory) {
        $location.path('/confirmrego');
        return;
      }

      if (smooth.forms.booking && smooth.forms.booking.length) {
        var doBooking = false;
        smooth.forms.booking.forEach(function (form) {
          if (form.serviceid === 'default' || form.serviceid === review.serviceID) {
            doBooking = true;
          }
        });

        if (doBooking) {
          $location.path('/bookingform');
          return;
        }
      } // Go to payment page if required


      if (review.requiresPayment) {
        $location.path('/choose-payment');
        return;
      } // Don't send appointment objects to the server.


      var appointmentIDs = review.appointments.map(function (appointment) {
        return appointment._id;
      });
      $rootScope.throbber.show(); // No payment required. Confirm appointments and go to confirmation page.

      $http.put(API_URL + '/api/v1/calendar/appointment/confirmunpaid', {
        appointmentids: appointmentIDs
      }).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          if (response.alreadydeleted) {
            $rootScope.throbber.showError("Unfortunately an error has occurred with this reservation. We're very sorry but you will need to restart the reservation process", function () {
              localStorage.removeItem('reserved-appointments');
              $location.path('/');
            });
            return;
          }

          return $rootScope.throbber.showError('Sorry but there was an error with this query ' + response.msg);
        } // Update local storage, redirect to confirmation page


        localStorage.removeItem('reserved-appointments');
        localStorage.setItem('new-appointments', JSON.stringify(response.appointments));
        $location.path('/confirm');
      });
    };

    review.unreserveAppointment = function ($index, appointment) {
      $rootScope.throbber.show();
      $http.put(API_URL + '/api/v1/calendar/appointment/unreserve', {
        appointments: [appointment]
      }).then(function () {
        $rootScope.throbber.hide('Appointment unreserved');
        localStorage.removeItem('reserved-appointments');
        review.appointments.splice($index, 1);

        if (!review.appointments.length) {
          $location.path('/');
        }

        localStorage.setItem('reserved-appointments', JSON.stringify(review.appointments));
      });
    };

    review.cancel = function () {
      var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

      if (!confirm(cancelMessage)) {
        return;
      }

      $location.path('/');
    };
  }
})();